<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-08-21 10:31:19
-->
<template>
    <div>
        <a-tabs :active-key="activeKey" @tab-click="(val)=>tabClick(val)">
            <a-tab-pane key="1" :title="$t('returnExchange.return')"></a-tab-pane>
            <a-tab-pane key="2" :title="$t('returnExchange.exchange')"></a-tab-pane>
            <a-tab-pane key="3" :title="$t('order.reissue')"></a-tab-pane>
            <a-tab-pane key="4" :title="$t('order.returnFactory')"></a-tab-pane>
        </a-tabs>
        
        <ReturnList v-if="activeKey == 1" :visible="props.visible" :rowData="rowData"></ReturnList>
        <ExchangeList v-if="activeKey == 2" :visible="props.visible" :rowData="rowData"></ExchangeList>
        <ReissueList v-if="activeKey == 3" :visible="props.visible" :rowData="rowData"></ReissueList>
        <ReturnFactoryList v-if="activeKey == 4" :visible="props.visible" :rowData="rowData"></ReturnFactoryList>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import ReturnList from './ReturnList.vue';
    import ExchangeList from './ExchangeList.vue';
    import ReissueList from './ReissueList.vue';
    import ReturnFactoryList from './ReturnFactoryList.vue';
    import { useI18n } from 'vue-i18n';

    const emits = defineEmits(['switchTab'])
    const props = defineProps({
        visible:{
            type:Boolean,
            default:false
        },
        rowData:{
            type:Object,
            default:()=>{}
        },
        active:{
            type:Number
        },
    })
    const { t } = useI18n()
    const activeKey = ref(props.active)

    const tabClick = (val)=>{
        activeKey.value = val
        emits('switchTab',val)
    }

    watch(()=>props.visible,(val)=>{
        activeKey.value = props.active
    })

    onMounted(()=>{
        
    })
</script>

<style lang="less" scoped>
.collapse{
    margin-bottom: 10px;
    /deep/ .arco-collapse-item-content{
        background-color: #fff;
    }

    .form_btn{
        margin: 0 10px;
    }
}
/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}
</style>